<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.name"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @phoneLink="phoneLinkFun"
        @certificateNoLink="certificateNoLinkFun"
      />
    </div>
    <view-dialog
      :select-item="selectItem"
      :view-type="viewType"
      :dialog-visible.sync="dialogVisible"
      dialog-title="零售户信息"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import ViewDialog from './components/viewDialog'
// 数据请求
import { loadOutsideStoreStatisticsListDataApi, loadOutsideStoreStatisticsExportDataApi } from '@/api/outsideUserStatistics'
export default {
  name: 'OutsideStoreStatistics',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'outside_store_statistics_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['statistics_outside_store_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            name: ''
          }
        }
      },
      id: null, // 选中的单据ID
      dialogVisible: false,
      selectItem: null, // 选中行
      viewType: null // 查看明细类型
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceNames', label: '省区', filterColumn: 'area.province_names', width: 100 },
      { prop: 'cityNames', label: '城市', filterColumn: 'area.city_names', width: 100 },
      { prop: 'countyNames', label: '区县', filterColumn: 'area.county_names', width: 100 },
      { prop: 'userName', label: '人员', filterColumn: 'r.user_name', width: 120 },
      { prop: 'total', label: '档案总数', filterColumn: 'r.user_name', width: 120 },
      { prop: 'visitTotal', label: '维护中户数', filterColumn: 'r.user_name', width: 120 },
      { prop: 'notDingAmount', label: '未同步钉钉', filterColumn: 'r.user_name', width: 120 },
      { prop: 'noOwnerAmount', label: '缺店主', filterColumn: 'r.user_name', width: 100 },
      { prop: 'noPhoneAmount', label: '缺电话', filterColumn: 'r.user_name', width: 100 },
      { prop: 'noBenxiangAmount', label: '缺门店码编码', filterColumn: 'r.user_name', width: 160 },
      { prop: 'noTagAmount', label: '缺标签', filterColumn: 'r.user_name', width: 100 },
      { prop: 'doublePhone', label: '电话重复', filterColumn: 'r.user_name', isCustomLink: true, customLinkFun: 'phoneLink' },
      { prop: 'doubleCertificateNo', label: '专卖证重复', filterColumn: 'r.user_name', isCustomLink: true, customLinkFun: 'certificateNoLink' }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadOutsideStoreStatisticsListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.prop = ''
      this.masterList.tableQuery.sort.order = ''
      this.loadTableData()
    },
    phoneLinkFun (rowData) {
      this.viewType = 1
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    certificateNoLinkFun (rowData) {
      this.viewType = 2
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadOutsideStoreStatisticsExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
